export enum OUTCOME_TYPE {
  WAY_HOME = '1',
  WAY_DRAW = '2',
  WAY_AWAY = '3',
  TWO_WAY_HOME = '4',
  TWO_WAY_AWAY = '5',
  HANDICAP_HOME = '1714',
  HANDICAP_AWAY = '1715',
  TOTAL_UNDER = '13',
  TOTAL_OVER = '12',
}

export enum LS_OUTCOME_TYPE {
  WAY_HOME = '5',
  WAY_DRAW = '6',
  WAY_AWAY = '7',
  HANDICAP_HOME = '3',
  HANDICAP_AWAY = '4',
  TOTAL_UNDER = '1',
  TOTAL_OVER = '2',
}
